@import 'styles/mixins';
@import 'styles/variables';

.iconContainer {
  display: flex;
  position: relative;
  max-width: 20px;

  .handbookIcon {
    margin-bottom: 3px;
  }
}
